import { createContext } from 'react';

// The context itself is safe to read while rendering public HTML. Importing
// it must not initialize Firebase, App Check, analytics, or account workflows.
export const AuthContext = createContext(null);
